import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Home() {
  return (
    <Box>
      <Typography variant="h3" component="h3">
        Welcome to Brain Based Health Solutions
      </Typography>
    </Box>
  );
}
